/* Étiquette Magique — upsell drawer (nudge enfants/2 maisons + recharge 1-clic)
   Chargé globalement via snippet em-cart-upsell.liquid. Délégation sur document
   (le drawer se reconstruit par innerHTML, donc pas de listener local durable).
   Données statiques dans window.EM_DRW (modèle -> variante tampon-supplementaire). */
(function () {
  'use strict';
  if (window.__emDrwInit) return;
  window.__emDrwInit = true;

  function data() { return window.EM_DRW || { family: {}, extraMap: {}, recharge: 0 }; }

  function isStamp(line) {
    var d = data();
    return line.handle === 'tampon-supplementaire' || !!d.family[line.handle];
  }

  // Reconstitue le modèle d'une ligne panier = "Famille — Variante" (clé de extraMap)
  function modelOfLine(line) {
    var d = data();
    if (line.handle === 'tampon-supplementaire') return line.variant_title;
    var fam = d.family[line.handle];
    if (!fam) return null;
    var opt = line.variant_title;
    if (!opt && line.options_with_values && line.options_with_values.length) {
      opt = line.options_with_values[0].value;
    }
    if (!opt) return null;
    return fam + ' — ' + opt; // em dash pour matcher les titres de variante
  }

  function vidForModel(model) {
    var d = data();
    return (model && d.extraMap[model]) ? d.extraMap[model] : null;
  }

  function copyProps(props) {
    var out = {};
    if (!props) return out;
    ['Première ligne', 'Deuxième ligne', 'Prénom', 'Nom ou téléphone', 'Modèle', 'Icône'].forEach(function (k) {
      if (props[k] != null && props[k] !== '') out[k] = props[k];
    });
    return out;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  // Rafraîchit le drawer via l'API publique du thème (re-render + reste ouvert).
  // Sur la page /cart (pas le drawer), un reload reflète le nouvel article.
  function refresh() {
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    if (window.theme && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') {
      theme.ajaxCart.update();
      if (window.timber && timber.RightDrawer && typeof timber.RightDrawer.open === 'function') {
        try { timber.RightDrawer.open(); } catch (e) {}
      }
    } else {
      window.location.href = '/cart';
    }
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = !!on;
    btn.classList.toggle('em-drw-busy', !!on);
  }

  // Rendu du sélecteur d'icône dans le formulaire "un autre enfant"
  function renderChildIcons(container) {
    var ic = data().icon;
    if (!container || !ic || container.getAttribute('data-built')) return;
    container.setAttribute('data-built', '1');
    function nice(n) { return ic.LABEL[n] || n.replace(/_/g, ' '); }
    function icoUrl(n) { return (window.EM_ICONS && window.EM_ICONS[n]) || ''; }
    var grid = document.createElement('div'); grid.className = 'em-drw-ic-grid';
    function draw() {
      grid.innerHTML = '';
      var none = document.createElement('div');
      none.className = 'em-drw-ic none' + (container.getAttribute('data-icon') === 'Aucune' ? ' on' : '');
      none.textContent = 'Aucune';
      none.onclick = function () { container.setAttribute('data-icon', 'Aucune'); draw(); };
      grid.appendChild(none);
      (ic.FLAT || []).forEach(function (n) {
        var d = document.createElement('div');
        d.className = 'em-drw-ic' + (container.getAttribute('data-icon') === nice(n) ? ' on' : '');
        d.title = nice(n);
        d.innerHTML = '<img loading="lazy" src="' + icoUrl(n) + '" alt="' + nice(n) + '">';
        d.onclick = function () { container.setAttribute('data-icon', nice(n)); draw(); };
        grid.appendChild(d);
      });
    }
    draw();
    container.appendChild(grid);
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    if (el && el.nodeType === 3) el = el.parentElement;
    if (!el || !el.closest) return;
    var t = el.closest('[data-em-action]');
    if (!t) return;
    var action = t.getAttribute('data-em-action');

    // Déplier / replier le champ prénom
    if (action === 'toggle-child') {
      e.preventDefault();
      var box = document.querySelector('.em-drw-child-form');
      if (box) {
        box.classList.toggle('em-drw-hide');
        if (!box.classList.contains('em-drw-hide')) {
          renderChildIcons(box.querySelector('.em-drw-child-icons'));
          var f = box.querySelector('.em-drw-child-name');
          if (f) f.focus();
        }
      }
      return;
    }

    // Ajouter un autre enfant : même modèle que le 1er tampon, nouveau prénom
    if (action === 'add-child') {
      e.preventDefault();
      var form = t.closest('.em-drw-child-form') || document;
      var inp = form.querySelector('.em-drw-child-name');
      var err = form.querySelector('.em-drw-err');
      var iconWrap = form.querySelector('.em-drw-child-icons');
      var chosenIcon = iconWrap ? (iconWrap.getAttribute('data-icon') || 'Aucune') : 'Aucune';
      var name = inp ? inp.value.trim() : '';
      if (err) err.textContent = '';
      if (!name) { if (err) err.textContent = 'Entrez un prénom.'; if (inp) inp.focus(); return; }
      busy(t, true);
      getCart().then(function (cart) {
        var ref = (cart.items || []).filter(isStamp)[0];
        if (!ref) throw new Error('no-ref');
        var vid = vidForModel(modelOfLine(ref));
        if (!vid) throw new Error('no-vid');
        var nameKey = (ref.properties && ref.properties['Prénom'] !== undefined) ? 'Prénom' : 'Première ligne';
        var props = {}; props[nameKey] = name; props['Icône'] = chosenIcon;
        return addItems([{ id: vid, quantity: 1, properties: props }]);
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { refresh(); })
        .catch(function () { busy(t, false); if (err) err.textContent = 'Oups, réessayez.'; });
      return;
    }

    // 2e maison : duplique tout le jeu de tampons du panier en -20%
    if (action === 'add-home') {
      e.preventDefault();
      busy(t, true);
      getCart().then(function (cart) {
        var items = (cart.items || []).filter(isStamp).map(function (line) {
          var vid = vidForModel(modelOfLine(line));
          if (!vid) return null;
          return { id: vid, quantity: line.quantity, properties: copyProps(line.properties) };
        }).filter(Boolean);
        if (!items.length) throw new Error('empty');
        return addItems(items);
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { refresh(); })
        .catch(function () { busy(t, false); });
      return;
    }

    // Recharge d'encre 1-clic (variante portée par data-vid, adaptée au panier)
    if (action === 'add-refill') {
      e.preventDefault();
      var rid = parseInt(t.getAttribute('data-vid'), 10) || data().recharge;
      if (!rid) return;
      busy(t, true);
      addItems([{ id: rid, quantity: 1 }])
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { refresh(); })
        .catch(function () { busy(t, false); });
      return;
    }
  }, false);
})();
